import { exception } from 'utils/analytics'

const PREVENT_THROW = false

export default function handle({ code, type, description, message, extra }) {
  log({ code, type, description, message, extra })
}

export function log(...args) {
  const [{ message, stack, pathname }] = args

  if (process.env.REACT_APP_ENABLE_EXCEPTION_LOGGING === 'true') {
    exception({
      message,
      stack,
      pathname,
    })
  }
  if (process.env.REACT_APP_ENABLE_CONSOLE_ERROR_LOGGING === 'true') {
    console.error(args)
  }
}

export function onerror(msg, url, lineNo, columnNo, error) {
  captureError(error)
  if (PREVENT_THROW) return false
  return error
}

export function onunhandledrejection(event) {
  const { reason } = event
  const error = new Error(`Unhandled Rejection: ${reason}`)
  captureError(error)
  return false
}

export function captureError({ name, line, stack }) {
  const { pathname } = new URL(window.location.href)
  const message = line || name
  const data = {
    message,
    stack,
    pathname,
  }

  log(data)
}

export function setup() {
  if (window) {
    window.onerror = onerror
    window.onunhandledrejection = onunhandledrejection
  }
}
